import { requestWithFallback } from '../httpClient';

export async function createCrashReport(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'errorReports',
        endpoint: 'create',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
        timeout: 8000,
        dedupeInFlight: false,
    });

    return result.data;
}
